import { ReactNode } from "react";
import Container from "@/components/base/Container";
import Breadcrumbs, { Crumb } from "@/components/feature/Breadcrumbs";

type PageHeaderProps = {
  crumbs: Crumb[];
  eyebrow: string;
  title: string;
  description: string;
  children?: ReactNode;
};

export default function PageHeader({ crumbs, eyebrow, title, description, children }: PageHeaderProps) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <Container className="py-8 md:py-12">
        <Breadcrumbs items={crumbs} />
        <div className="mt-6 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="text-xs font-medium tracking-[0.22em] text-primary-600">{eyebrow}</span>
            <h1 className="mt-3 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
              {title}
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
          </div>
          {children}
        </div>
      </Container>
    </section>
  );
}